<template>
  <div ref="image" class="format-block">
    <div class="flex-wrapper">
      <h3 class="format-block-title">Thumbnail</h3>
    </div>
    <div class="upload-block">
      <button class="action-button" @click="$refs.fileInput.click()">
        {{ $t("create.step3.thumbnailSelector.upload") }}
      </button>
      <button class="action-button" @click="takeScreenShot()">
        {{ $t("create.step3.thumbnailSelector.screenshot") }}
      </button>
      <p class="screenshot-indication">
        {{ $t("create.step3.thumbnailSelector.tip") }}
      </p>
      <input
        ref="fileInput"
        style="display: none"
        accept=".jpeg, .jpg, .png"
        type="file"
        @change="onFileChanged"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasThumbnail: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    video: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      addThumbnail: false,
    };
  },

  created() {
    this.addThumbnail = this.hasThumbnail;
  },
  methods: {
    changeThumbnail() {
      this.addThumbnail = !this.addThumbnail;
      if (!this.addThumbnail) {
        this.$emit("upload-image", { blob: "", tempThumbnailFile: "" });
      } else {
        this.$emit("scroll-to-bottom");
      }
    },
    async takeScreenShot() {
      try {
        const videoUrl = this.video?.url || "";

        if (!videoUrl) {
          throw new Error("Video URL not available");
        }

        const video = document.createElement("video");
        video.muted = true;
        video.playsInline = true;

        video.crossOrigin = "anonymous";
        const response = await fetch(videoUrl, { mode: "cors" });
        if (!response.ok) throw new Error("Fetch failed");
        const blob = await response.blob();
        video.src = URL.createObjectURL(blob);

        await new Promise((resolve) => {
          video.addEventListener("loadeddata", resolve);
        });

        const originalVideo = document.querySelector(".vidjet-video");
        if (originalVideo) {
          video.currentTime = originalVideo.currentTime;
          await new Promise((resolve) =>
            video.addEventListener("seeked", resolve)
          );
        }

        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas
          .getContext("2d")
          .drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
          this.$emit("upload-image", {
            blob: URL.createObjectURL(blob),
            tempThumbnailFile: blob,
          });
          URL.revokeObjectURL(video.src);
        }, "image/png");

        this.notifyChangeThumbnail();
      } catch (error) {
        console.error(error);
        const originalVideo = document.querySelector(".vidjet-video");
        if (
          originalVideo &&
          originalVideo.videoWidth &&
          originalVideo.videoHeight
        ) {
          try {
            this.captureToCanvas(originalVideo);
            return;
          } catch (fallbackError) {
            console.error("Fallback screenshot also failed", fallbackError);
          }
        }
        this.$notify({
          title: this.$t("shared.toastMessage.error"),
          text: "Screenshot failed, try to upload an image",
          type: "error",
        });
      }
    },
    captureToCanvas(video) {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      canvas.toBlob((blob) => {
        if (blob) {
          this.$emit("upload-image", {
            blob: URL.createObjectURL(blob),
            tempThumbnailFile: blob,
          });
          this.notifyChangeThumbnail();
        } else {
          throw new Error("Canvas toBlob failed");
        }
      }, "image/png");
    },

    onFileChanged(payload) {
      const file = payload.target.files[0];
      this.$emit("upload-image", {
        blob: URL.createObjectURL(file),
        tempThumbnailFile: file,
      });
      this.notifyChangeThumbnail();
    },

    notifyChangeThumbnail() {
      this.$notify({
        title: this.$t("shared.toastMessage.success"),
        text: this.$t("shared.toastMessage.thumbnail"),
        type: "success",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-btn-cta {
  position: absolute;
  top: 7px;
  right: 10px;
}

.flex-wrapper {
  width: 100%;
  position: relative;
}

.upload-block {
  display: flex;
  flex-direction: column;
  align-self: center;
  gap: 16px;
  width: 100%;
}

.screenshot-indication {
  @include base-font;
  @include font-small;
  width: 100%;
  color: $dark-grey;
}

.thumbnail-btn {
  background-color: white;
  border: 1px solid $dark-grey;
  border-radius: 4px;
  padding: 4px;
  align-self: flex-start;
  @include base-font;
  color: $dark-grey;
}
</style>
